import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteProfileMutation, deleteProfileMutationVariables } from '../generated/deleteProfileMutation';
import { profileFieldsFragment } from '../models/Profile';

/**
 * Get a callback to delete a Profile in the store.
 */
export function useDeleteProfileCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteProfileMutation, deleteProfileMutationVariables>(
        gql`
            mutation deleteProfileMutation ($id: ID!) {
                deleteProfile(id: $id) {
                    ...profileFields
                }
            }

            ${profileFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
